import { render, staticRenderFns } from "./fanshuirecord.vue?vue&type=template&id=2209307c"
import script from "./fanshuirecord.vue?vue&type=script&lang=js"
export * from "./fanshuirecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports